(() => {
  const StickyProductMobile = () => {
    let breakpoint = window.matchMedia('(max-width: 589px)');
    breakpoint.addEventListener('change', (e) => {
      setTimeout(() => {
        theme.headerNav[e.matches ? 'enableOverlayHeader' : 'disableOverlayHeader']();
      }, 0);
    });

    theme.headerNav[breakpoint.matches ? 'enableOverlayHeader' : 'disableOverlayHeader']();
  }

  const DOMReady = () => {
    StickyProductMobile();
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();